import React from 'react';
import CaseCard from './CaseCard';
import { CardStack } from './CaseListUI';

// Made-up sample cases, shown fully blurred behind "locked" messages
// (unverified firm, Premium-only cases). Purely decorative - never real data.
const daysAgo = (n) => new Date(Date.now() - n * 24 * 60 * 60 * 1000).toISOString();
export const SAMPLE_CASES = [
  { _id: 'sample1', caseNumber: 'CASE-1081', caseType: 'accident', caseCity: 'dallas', caseState: 'Texas', aiEstimateLowerValue: 350000, aiEstimateUpperValue: 850000, aiDifficulty: 5, created_at: daysAgo(1), dateInfo: daysAgo(40), aiDate: daysAgo(-600), isPostedBySelf: 'yes' },
  { _id: 'sample2', caseNumber: 'CASE-1079', caseType: 'malpractice', caseCity: 'houston', caseState: 'Texas', aiEstimateLowerValue: 800000, aiEstimateUpperValue: 2000000, aiDifficulty: 8, created_at: daysAgo(3), dateInfo: daysAgo(120), aiDate: daysAgo(-400), isPostedBySelf: 'yes' },
  { _id: 'sample3', caseNumber: 'CASE-1074', caseType: 'liability', caseCity: 'san antonio', caseState: 'Texas', aiEstimateLowerValue: 50000, aiEstimateUpperValue: 250000, aiDifficulty: 4, created_at: daysAgo(6), dateInfo: daysAgo(20), aiDate: daysAgo(-700), isPostedBySelf: 'yes' },
];

// Blurred sample case cards; `count` picks how many.
export function BlurredSampleCases({ count = 3, className = '' }) {
  return (
    <div aria-hidden className={`blur-[4px] opacity-75 pointer-events-none select-none ${className}`}>
      <CardStack>
        {SAMPLE_CASES.slice(0, count).map((d) => (
          <CaseCard key={d._id} detail={d} userInfo={{ isActiveSubscription: false }} reqRevCountArr={{}} hideStats />
        ))}
      </CardStack>
    </div>
  );
}

export default BlurredSampleCases;
